import React from "react";
import { Grid, Box } from "@material-ui/core";
import useStyles from "../common/Styles";
import AboutTogglebar from "../common/AboutTogglebar";
import ChartView from "./ChartView";
import { charts, about } from "./constants";
import { useSelector } from "react-redux";
// import { decimalRoundHelper } from "../common/utils";
import userActions from "../common/actions";
import CitiesMetrics from "./CitiesMetrics";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import toggleIcon from '../../../../assets/slide-out-icon.png';

const CitiesView = () => {
  const classes = useStyles();
  const { windowDimension } = useGetViewPortDimensions();
  const { chart_selected, toggle_about } = useSelector((state) => state.water_user);
  const { toggleAboutDrawer } = userActions();

return (
    <Grid container item style={{ height: windowDimension.winHeight - 110, width: windowDimension.winWidth, flexDirection: 'column', zIndex: 1 }}>
        {!toggle_about ? (
            <Grid item>
                <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
            </Grid>
        ) : (
            <Box className={classes.aboutDrawerResponsive}>
                <AboutTogglebar
                    MetricsComponent={charts[chart_selected].show_stats ? <CitiesMetrics /> : undefined}
                    about={about[chart_selected >= charts.length ? 0 : chart_selected]}
                />
            </Box>
        )}
        {!toggle_about ? (
            <Grid container item justify="center" alignItems="center" className={classes.aboutTogglebarResponsive} onClick={toggleAboutDrawer}>
                <img src={toggleIcon} className={classes.aboutToggleIconResponsive} alt="toggle-icon.png" />
            </Grid>
        ) : null}
    </Grid>
)
};

export default CitiesView;
